import {EventEmitter} from 'eventemitter3'

export const staticListEvent = new EventEmitter()

export const staticListEventTypes = {
    TABLE_CHANGE: 'TABLE_CHANGE',
}

export function getStaticListEventKey(eventType) {
    if (!eventType) {
        return ''
    }

    switch (eventType) {
        case staticListEventTypes.TABLE_CHANGE:
            return `STATIC_LIST_TABLE_CHANGE`

        default:
            return ''
    }
}

//#region TABLE CHANGE
export function onStaticListTableChangeListener(
    eventType = staticListEventTypes.TABLE_CHANGE,
    data,
) {
    staticListEvent.emit(getStaticListEventKey(eventType), data)
}

export function onStaticListTableChangeRemoveListener(
    eventType = staticListEventTypes.TABLE_CHANGE,
) {
    staticListEvent.removeListener(getStaticListEventKey(eventType))
}
//#endregion
